import { logger } from '#pplx/frontend/logger/browser.js';
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY_MIGRATION: Please fix in passing
export function logEmailSignIn(...toLog) {
    logWithTime('[email_signin_flow] ', ...toLog);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY_MIGRATION: Please fix in passing
export function logWithTime(...toLog) {
    const date = new Date().toISOString();
    logger.log(`[${date}] `, ...toLog);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY_MIGRATION: Please fix in passing
export function warnWithTime(...toLog) {
    const date = new Date().toISOString();
    logger.warn(`[${date}] `, ...toLog);
}
//# sourceMappingURL=logging.js.map